import { render, staticRenderFns } from "./ImzalayiciV2.vue?vue&type=template&id=0cb8dab5&scoped=true&"
import script from "./ImzalayiciV2.vue?vue&type=script&lang=js&"
export * from "./ImzalayiciV2.vue?vue&type=script&lang=js&"
import style0 from "./ImzalayiciV2.vue?vue&type=style&index=0&id=0cb8dab5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb8dab5",
  null
  
)

export default component.exports